// extracted by mini-css-extract-plugin
export default {"folderOrFileText":"Documents_folderOrFileText__Blj5-","paper":"Documents_paper__tRyJE","icon":"Documents_icon__LQE5A"};